import { useState } from 'react';

import ConsultaSaqueFacil from '../../components/ConsultaSaqueFacil/ConsultaSaqueFacil';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function SaqueFacil() {
    const [notify, setNotify] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });

    return (
        <>
            {notify.isActive && <NotifierPopup notify={notify} setNotify={setNotify} />}
            <ConsultaSaqueFacil
                setNotifier={(isSuccessful, message) => setNotify({
                    isActive: true,
                    isSuccessful,
                    message
                })}
            />
        </>
    );
}
